import { createFileRoute } from '@tanstack/react-router';
import { TeamDeadlinesPage } from '@/features/obligations/TeamDeadlinesPage';

/**
 * Chi del team è in ritardo con le scadenze (task 1921). Ci portano la voce «Scadenze del team» in
 * «Il mio lavoro», la segnalazione al responsabile e «Richiede attenzione» della home.
 */
export const Route = createFileRoute('/_app/team-deadlines')({ component: TeamDeadlinesPage });
